import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Ui::Protection::Settings::Page @page={{this}} />\n",{ moduleName: "uplisting-frontend/pods/protection/settings/template.hbs" })